import { AssetApi } from "../api/api"
import { AssetBasicDataProvider, AssetPageBase } from "./asset_page_base"
import { AssetEditPageBase } from "./asset_edit_page_base"
import { JqElm, UiUtils } from "./ui"
import { QueryAsset, AssetStatusEnum, PagedListResult, Asset, AssetTypeEnum, Dict } from "../api/model"
import { Pagination } from "../utils/pagination"
import { splitIgnoreEmpty } from "../utils/string"
import { inspect } from "util"
import { cleanProperties } from "../utils/core"


export type RefineAssetQuery = (queryAsset: QueryAsset) => void
export type QueryResultCallback = (err: any, result: PagedListResult<Asset>) => void
export class AssetSearchBlockBuilder {

    private static readonly DefaultMaxCount = 10
    queryAsset: QueryAsset
    assetMap?: Dict<Asset>
    pagination?: Pagination
    refineAssetQuery?: RefineAssetQuery
    constructor(
        public assetApi: AssetApi,
        public assetBasicDataProvider: AssetBasicDataProvider,
        public toListenFacilityEnable: boolean,
        public queryResultCallback: QueryResultCallback
    ) {

    }

    withQueryAsset(queryAsset: QueryAsset): AssetSearchBlockBuilder {
        this.queryAsset = queryAsset
        return this
    }

    withAssetMap(assetMap: Dict<Asset>): AssetSearchBlockBuilder {
        this.assetMap = assetMap
        return this
    }
    withPagination(pagination: Pagination): AssetSearchBlockBuilder {
        this.pagination = pagination
        return this
    }
    withRefineAssetQuery(refineAssetQuery: RefineAssetQuery): AssetSearchBlockBuilder {
        this.refineAssetQuery = refineAssetQuery
        return this
    }

    build(): AssetSearchBlock {
        if (this.queryAsset == null) {
            this.withQueryAsset({
                maxCount: AssetSearchBlockBuilder.DefaultMaxCount,
                orderBy: "displayId",
                orderByDescending: true
            })
        }
        return new AssetSearchBlock(this)
    }

}

export class AssetSearchBlock extends AssetPageBase {

    private static readonly DefaultMaxCount = 10
    private queryAsset: QueryAsset
    private toListenFacilityEnable: boolean
    private queryResultCallback: QueryResultCallback
    private assetMap?: Dict<Asset>
    private pagination?: Pagination
    private refineAssetQuery?: RefineAssetQuery


    constructor(
        builder: AssetSearchBlockBuilder
    ) {
        super(builder.assetApi, builder.assetBasicDataProvider)
        this.queryAsset = builder.queryAsset
        this.queryResultCallback = builder.queryResultCallback
        this.toListenFacilityEnable = builder.toListenFacilityEnable
        this.assetMap = builder.assetMap
        this.pagination = builder.pagination
        this.refineAssetQuery = builder.refineAssetQuery
    }


    load() {
        this.initSearchElms()
    }

    initSearchElms() {
        const rootCatSelectElm = this.elmById("search", null, "categoryRootId")
        AssetEditPageBase.fillCategoryElmData(
            rootCatSelectElm,
            this.elmById("search", null, "categoryId"),
            this.assetBasicDataProvider
        )
        rootCatSelectElm.append(UiUtils.options("待分類", "-1"))
        const areaSelectElm = this.elmById("search", null, "areaId")
        AssetEditPageBase.fillAreaElmData(areaSelectElm, this.assetBasicDataProvider)
        AssetEditPageBase.appendOtherAreaOption(areaSelectElm)
        this.listenCodeScanClick()
        this.listenCleanFilterClick()
        if (this.toListenFacilityEnable) {
            this.listenFacilityEnableChange()
            this.listenFacilityIdsChange()
            this.initFacilityModal()
        }
        this.listenSearchClick()
    }

    private listenCodeScanClick() {
        const modal = $('#code_scan_modal')
        const manualModal = $('#code_scan_manual_modal')
        modal.find('.icon-close').click(() => {
            modal.hide()
        })
        manualModal.find('.icon-close').click(() => {
            manualModal.hide()
        })
        $('#code_scan_manual_modal_confirm').click(() => {
            manualModal.hide()
        })
        $('#code_scan_manual_btn').click(() => {
            manualModal.show()
            modal.hide()
            this.listenScanCodeInput(manualModal.find('[type=password]:first'), manualModal)
        })
        $('#id_scan').click(() => {
            modal.show()
            this.listenScanCodeInput(modal.find('[type=password]:first'), modal)
        })
    }

    private listenScanCodeInput(inputElm: JqElm, modalElm: JqElm) {
        const fakeInputElm = modalElm.find('.fakeInput').html('請輸入條碼')
        inputElm
            .val('').focus().off('keyup').off('blur')
            .keyup(e => {
                console.log("keyup")
                const elm = $(e.currentTarget)
                if (e.keyCode == 13) {
                    modalElm.hide()
                } else {
                    elm.focus()
                    this.elmById('search', null, 'id').val(elm.val())
                    fakeInputElm.text(<string>elm.val())
                }
            }).blur(e => {
                console.log("Blur")
                const elm = $(e.currentTarget)
                elm.val('').focus()
            })
    }

    private listenCleanFilterClick() {
        $('#clean_filter').click(e => {
            this.cleanFilterUi()
            this.queryByFilterElms()
        })
    }

    cleanFilterUi() {
        this.elmById("search", null, "name").val('')
        this.elmById("search", null, "id").val('')
        this.elmById("search", null, "categoryRootId").val('').change()
        this.elmById("search", null, "areaId").val('').change()
        UiUtils.setChecked(this.elmById("search", null, "type_search"), false).change()
        UiUtils.setChecked(this.elmById("search", null, "guestLoanable"), false).change()
        UiUtils.setChecked(this.elmById("search", null, "facilityEnable"), false).change()
    }

    private listenSearchClick() {
        $('#search').click(e => {
            this.queryByFilterElms()
        })
    }

    private listenFacilityEnableChange() {
        console.log("ListenFacilityEnable")

        this.elmById("search", null, "facilityEnable").change(e => {
            console.log("facilityEnable changed")
            AssetEditPageBase.facilityEnableElmChanged($(e.target))
        })
    }

    private listenFacilityIdsChange() {
        this.elmById("search", null, "facilityIds").change(e => {
            const elm = $(e.target)
            AssetEditPageBase.facilityIdsElmChanged(elm, this.assetBasicDataProvider)
        })
    }

    private initFacilityModal() {
        AssetEditPageBase.initFacilityModal()
        AssetEditPageBase.initFacilityElms(this.assetBasicDataProvider)
    }

    private queryByFilterElms(): Promise<PagedListResult<Asset>> {
        const nameVal = <string>this.elmById("search", null, "name").val()
        const idVal = <string>this.elmById("search", null, "id").val()
        const facilityIdVal = splitIgnoreEmpty(<string>this.elmById("search", null, "facilityIds").val(), ',')
        const categoryIdVal = this.elmById("search", null, "categoryId").val()
        const areaIdVal = Number(this.elmById("search", null, "areaId").val())
        const typeVal = <AssetTypeEnum>this.elmById("search", null, "type_search", ':checked').val()
        const guestLoanableVal = Boolean(this.elmById("search", null, "guestLoanable", ":checked").val())
        const facilityEnableVal = Boolean(this.elmById("search", null, "facilityEnable", ":checked").val())
        const statusVal = <string>this.elmById("search", null, "status").val()
        this.queryAsset.offset = 0
        this.queryAsset.name = nameVal.length != 0 ? nameVal : null
        this.queryAsset.displayId = idVal.length != 0 ? idVal : null
        this.queryAsset.facilityIds = facilityIdVal.length != 0 ? facilityIdVal : null
        this.queryAsset.areaId = areaIdVal != 0 ? areaIdVal : null
        this.queryAsset.type = typeVal
        this.queryAsset.guestLoanable = guestLoanableVal ? true : null
        this.queryAsset.status = statusVal != "" ? <AssetStatusEnum>statusVal : null
        if (categoryIdVal != null) {
            let cats = [Number(categoryIdVal)]
            if (categoryIdVal == 0) {
                const rootCatId = Number(this.elmById('search', null, 'categoryRootId').val())
                cats = this.assetBasicDataProvider.catParentMap.get(rootCatId).map(it => it.id)
            }
            this.queryAsset.categoryIds = cats
        } else {
            if (this.elmById("search", null, "categoryRootId").val() == '-1') {
                this.queryAsset.categoryIds = [-1]
            } else {
                this.queryAsset.categoryIds = null
            }
        }
        this.queryAsset.withFacility = facilityEnableVal ? true : null
        if (this.refineAssetQuery != null) {
            this.refineAssetQuery(this.queryAsset)
        }
        console.log("Query for assets:%s", inspect(this.queryAsset, null, 2))
        const rt = this.queryAssets()
        rt.then(result => this.queryResultCallback(null, result)).catch(e => this.queryResultCallback(e, null))
        return rt
    }

    queryAssets(): Promise<PagedListResult<Asset>> {
        const promise = this.assetApi.query(this.queryAsset)
        promise.then(resp => {
            if (this.pagination != null) {
                this.pagination.updateByOffset(resp.total, resp.offset)
            }
            if (this.assetMap != null) {
                cleanProperties(this.assetMap)
                resp.data.forEach(asset => {
                    this.assetMap[asset.id] = asset
                })
            }
        })
        return promise
    }

    private getStatusFilterValue(statusFilterElm: JqElm): AssetStatusEnum | null {
        const statusVal = statusFilterElm.val()
        return statusVal != "" ? <AssetStatusEnum>statusVal : null
    }
}